import { Tabs } from '~/shared/components/tabs/Tabs';
import { QueryParamTabs } from '~/shared/components/tabs/QueryParamTabs';
import { EditUserForm } from './EditUserForm';
import { EditUserSubscriptionsForm } from './EditUserSubscriptionsForm';
import { PageLayout } from '~/shared/PageLayout';
import { UserIcon } from 'lucide-react';
import { PageSection } from '~/shared/section/PageSection';
import { useParams } from 'react-router-dom';
import { getUserOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ContentSizeWrapper } from '~/shared/ContentSizeWrapper';

const views = [
	{ label: 'General', value: 'general' },
	{ label: 'Subscriptions', value: 'subscriptions' }
];

export function EditUserForms() {
	const { id } = useParams<'id'>();
	const { data: user } = useSuspenseQuery(getUserOptions(id!));

	return (
		<PageLayout pageHeader={{ title: 'User Library' }}>
			<PageSection title="Edit User Settings" description={user.fullName} TitleIcon={UserIcon}>
				<ContentSizeWrapper>
					<QueryParamTabs defaultTab={views[0].value} className="gap-0">
						<Tabs.TabList aria-label="User Profile Sections">
							{views.map(view => (
								<Tabs.Tab id={view.value} key={view.value}>
									{view.label}
								</Tabs.Tab>
							))}
						</Tabs.TabList>
						<Tabs.TabPanel id="general" className="bg-white p-4">
							<EditUserForm user={user} />
						</Tabs.TabPanel>
						<Tabs.TabPanel id="contacts">
							<EditUserSubscriptionsForm />
						</Tabs.TabPanel>
					</QueryParamTabs>
				</ContentSizeWrapper>
			</PageSection>
		</PageLayout>
	);
}
